module.exports = __webpack_public_path__ + "img/132.6996d003.jpg";